import { useState, useEffect } from "react";
import apiFetch from "../../../../shared/services/apiClient";

/** Recibos CxP con saldo sin aplicar (espejo de usePendingReceipts de CxC). */
export function usePendingReceiptsCxP(refreshKey = 0) {
  const [pending, setPending] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    apiFetch("/api/finance/reciboCxP/pendientes/")
      .then((r) => r.json())
      .then((data) => {
        setPending(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [refreshKey]);

  return { pending, loading };
}

export function useReceiptCxP() {
  const [receiptData, setReceiptData] = useState({
    monto:           0,
    cuenta_bancaria: 0,
    metodo_pago:     "TRANSFERENCIA",
    documento:       "",
    fecha_pago:      new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().split("T")[0],
  });
  const [selectedProveedor, setSelectedProveedor] = useState(null); // CuentaContable id
  const [count,             setCount]             = useState(0);
  const [errors,            setErrors]            = useState({});

  function updateField(field, value) {
    setReceiptData(p => ({ ...p, [field]: value }));
    if (errors[field]) setErrors(p => { const e = { ...p }; delete e[field]; return e; });
  }

  function validate() {
    const e = {};
    if (!selectedProveedor)                                      e.proveedor      = "Seleccioná un proveedor.";
    if (!receiptData.monto || Number(receiptData.monto) <= 0)    e.monto          = "El monto debe ser mayor a 0.";
    if (!receiptData.fecha_pago)                                 e.fecha_pago     = "La fecha es obligatoria.";
    if (!receiptData.cuenta_bancaria || receiptData.cuenta_bancaria === 0) e.cuenta_bancaria = "Seleccioná una cuenta bancaria.";
    if (!receiptData.documento?.trim())                          e.documento      = "La referencia es obligatoria.";
    setErrors(e);
    return Object.keys(e).length === 0;
  }

  function clearErrors() { setErrors({}); }

  return {
    receiptData, setReceiptData, updateField,
    selectedProveedor, setSelectedProveedor,
    count, setCount,
    errors, validate, clearErrors,
  };
}
